/**
 * The one type system (brand-vibe review 2026-07-14, "one control system" — the
 * typographic analog of buttonClasses/cardClasses/fieldClasses).
 *
 * Semantic text roles so headings/labels read consistently across every surface
 * instead of drifting between `text-xl`/`text-lg`/`text-[15px]` ad hoc. Craft over
 * the locked identity: display type carries a slight NEGATIVE tracking (the modern
 * signal — tight, deliberate headings), the section eyebrow stays the small warm
 * uppercase label. Colors reference the themeable ink/muted tokens, so these roles
 * re-theme under the mini-app dark block for free.
 *
 * Usage: `<h1 className={typography.title}>`. Compose extra utilities with a
 * template string when a call site needs spacing, e.g. `` `mt-3 ${typography.title}` ``.
 */
export const typography = {
    /** Screen title (h1) — the largest type on a screen. */
    title: 'text-xl font-semibold tracking-tight text-ink',
    /** Card / entity heading (h2/h3 inside a card or list row). */
    heading: 'text-lg font-semibold tracking-tight text-ink',
    /** Section eyebrow — the small uppercase label above a group. */
    eyebrow: 'text-sm font-medium uppercase tracking-wide text-muted',
};
//# sourceMappingURL=typography.js.map